// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__2u9rI","info":"PatientInfo_info__3b48l"};